// Keys stay in snake_case: the rules are stored as JSON on the backend and are not camelCased on the way
export interface ArticleStatusRule {
    statuses: string[];
    is_blocking: boolean;
}

export const NEW_ARTICLE_STATUS_RULE: ArticleStatusRule = {
    statuses: [],
    is_blocking: true,
};

const cleanStatuses = (statuses: unknown): string[] =>
    (Array.isArray(statuses) ? statuses : [])
        .map((status) => String(status ?? '').trim())
        .filter((status) => status !== '');

export const normalizeArticleStatusRules = (rules?: ArticleStatusRule[] | null): ArticleStatusRule[] =>
    (rules || []).map((rule) => ({
        statuses: cleanStatuses(rule.statuses),
        is_blocking: rule.is_blocking ?? true,
    }));

export const validateArticleStatusRules = (rules?: ArticleStatusRule[] | null): boolean =>
    (rules || []).every((rule) => cleanStatuses(rule.statuses).length > 0);

// Pasted text comes from "Copy rules"; anything else must not reach the backend, which rejects unknown keys
export const parseArticleStatusRules = (text: string): ArticleStatusRule[] => {
    const parsed = JSON.parse(text);
    if (
        !Array.isArray(parsed) ||
        parsed.some((rule) => !rule || typeof rule !== 'object' || !Array.isArray(rule.statuses))
    ) {
        throw new Error('Expected a list of article status rules');
    }
    return normalizeArticleStatusRules(parsed);
};
